<template>
  <md-modal-dialog
    class="md-dialog"
    @md-opened="event = 'md-opened'"
    v-slot="{questions}"
    @md-clicked-outside="$modal.cancel()"
  >
    <ModalWrapper>
      <div class="survey-wrapper">
        <button class="btn-close" aria-label="Close" @click="$modal.cancel()">
          <IconCross />
        </button>

        <SurveyForm @close="onModalClose" :value="value" :questions="questions" @change="onChange" />
      </div>
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import Vue from 'vue';
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
import SurveyForm from './suvey-form.vue';
import IconCross from '../../svg/cross.vue';
Vue.use(VueCompositionAPI);

export default defineComponent({
  name: 'region-picker-dialog',
  components: {
    ModalWrapper,
    SurveyForm,
    IconCross,
  },
  data() {
    return {
      value: {},
    };
  },
  methods: {
    onChange(value) {
      this.value = value;
    },
    onModalClose() {
      this.$modal.submit(this.value);
    },
  },
});
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  ); */
  overflow: auto;
}
.btn-close {
  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 19px 0 20px;
  z-index: 1;
  position: absolute;
  font-size: 14px;
  color: #fff;
  appearance: none;
  border: none;
  cursor: pointer;
}
</style>

<style>
.md-dialog-container.md-theme-default {
  width: 100%;
  border-radius: 20px;
  /* overflow: auto !important; */
}
</style>
